module.exports = __webpack_public_path__ + "img/89.3e65cde5.jpg";